module.exports = __webpack_public_path__ + "static/media/piggy.6a7d1d0f.png";